import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const HomeView = () => import('@/views/HomeView.vue')
const TrainingView = () => import('@/views/TrainingView.vue')
const TrainingHomeView = () => import('@/views/TrainingHomeView.vue')
const KontaktView = () => import('@/views/KontaktView.vue')
const ImpressumView = () => import('@/views/ImpressumView.vue')
const DatenschutzView = () => import('@/views/DatenschutzView.vue')
const ErrorView = () => import('@/views/ErrorView.vue')

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/training',
    name: 'training',
    component: TrainingView
  },
  {
    path: '/training-zu-hause',
    name: 'training-home',
    component: TrainingHomeView
  },
  {
    path: '/kontakt',
    name: 'kontakt',
    component: KontaktView
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: ImpressumView
  },
  {
    path: '/datenschutz',
    name: 'datenschutz',
    component: DatenschutzView
  },
  {
    path: '/:catchAll(.*)',
    name: 'error',
    component: ErrorView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll up when a route is changed
    return { top: 0 }
  }
})

export default router
